export enum ShipmentCriticalTransitStatuses {
  Passing = 'PASSING',
  Passed = 'PASSED',
}
